const APP_RAISER = 'appraiser'
const SUPER_USER = 'Super User'
export default {
  namespaced: true,
  state: {
    username: '',
    user_roles: []
  },
  mutations: {
    setUserName(state, name) {
      state.username = name;
    },
    setUserRoles(state, roles) {
      state.user_roles = roles;
    }
  },
  getters: {
    isSuperuserOrAppraiser: (state) => state.user_roles.some(role => [APP_RAISER, SUPER_USER].includes(role))
  },
  actions: {
    updateUserName({commit}, {username}) {
      commit('setUserName', username);
      localStorage.setItem('username', username);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js